import { render, staticRenderFns } from "./master-svg.vue?vue&type=template&id=be52b5ca&"
import script from "./master-svg.vue?vue&type=script&lang=js&"
export * from "./master-svg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports